import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      // width: '80vw', 
      minWidth: 800,
    },
    modalContainer: {
      padding: "15px 25px",
      boxShadow: "1px 1px 6px rgba(56, 25, 81, 0.25)",
    },
    titleModal: {
      font: `700 16px/16px "Montserrat"`,
      marginBottom: 10,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      paddingRight: 10
    },
    subtitleModal: {
      font: `400 14px/18px "Montserrat"`,
      border: 'none'
    },
    paperModal: {
      margin: '0 auto',
      maxWidth: 1030,
    },
    contentModal: {
      padding: '8px 25px',
    },
    contentBodyModal: {
      display: 'flex',
      minHeight: '350px',
      alignItems: 'center',
      padding: '0 30px',
      marginBottom: 50,
      '&.d-top': {
        justifyContent: 'flex-start',
        marginBottom: 0,
        // minHeight: 450,
        flexDirection: 'column',
        maxWidth: 500,
        margin: '0 auto',
      }
    },
    closeButton: {
      position: 'absolute',
      right: 24,
      top: 10,
      color: '#000000',
      width: 30,
      height: 30,
    },
    modalFooter:{
      boxShadow: `1px 1px 6px rgba(56, 25, 81, 0.25)`,
      textAlign: 'right',
      padding: 15,
      '&>span': {
        cursor: 'pointer',
        font: theme.custom.font.headingMontserrat3,
      },
      '& .d-inline-block': {
        display: 'inline-block',
      }
    },
    btnCreateNew: {
      marginLeft: '20px',
      '& button': {
        height: 32,
        background: theme.custom.colors.midBlack,
        color: theme.custom.colors.white,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        font: theme.custom.font.headingMontserrat3,
        '&:disabled': {
          background: theme.custom.colors.borderGrey,
        },
        '&:hover': {
          background: theme.custom.colors.primary,
        },
      },
    },
    searchForm: {
        width: "100%",
        position: "relative"
    },
    headTypeSearch: {
      maxWidth: 500,
      width: '100%',
      marginTop: 50,
      position: 'relative',
      marginBottom: 5,
      borderBottom: `1px solid #000`,
      display: 'flex', 
      '& input': {
        boxShadow: 'none',
        border: 'none',
        // borderBottom: `1px solid #000`,
        font: theme.custom.font.paragraph,
        padding: '8px 10px',
        width: '95%',
        '&:focus': {
          outline: 'none'
        }
      }
    },
    iconSearch: {
      position: 'absolute',
      right: 0, 
      bottom: 10,
      cursor: 'pointer'
    },
    iconClose: {
        position: 'absolute',
      right: 0, 
      bottom: 5,
      cursor: 'pointer'
    },
    iconCloseAdd: {
      display: 'inline-flex',
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius:'50%',
      border: `2px solid ${theme.custom.colors.borderTable}`,
      position: 'absolute',
      top: 2,
      right: 2,
      cursor: 'pointer'
    },
    resultBox: {
        boxShadow: "1px 1px 6px rgba(56, 25, 81, 0.25)",
        width: "100%",
        borderRadius: '6px',
        position: 'absolute',
        background: 'white',
        zIndex: 1,
        maxHeight: 367, 
        overflow: 'auto'
    },
    resultTitle: {
        color: theme.custom.colors.purple,
        font: `700 10px/10px "Montserrat"`,
        margin: "12px 16px"
    },
    resultContent: {
        // paddingLeft: '12px'
    },
    resultText: {
        font: `400 14px/18px "Montserrat"`,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: "28px",
        "&:hover": {
            background: "#F0F0F0",
            cursor: 'pointer',
        }
    },
    textBold: {
      font: `700 14px/18px "Montserrat"`,
    },
    textNormal: {
      font: `400 14px/18px "Montserrat"`,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    textNoResult: {
        font: `400 14px/18px "Montserrat"`,
        margin: "12px 16px",
    },
    textAdd: {
        font: `700 14px/18px "Montserrat"`,
        margin: "12px 16px",
        color: theme.custom.colors.purple,
        cursor: 'pointer',
    },
    bodyTypeSearch: {
      overflow: 'auto',
      maxHeight: 370,
      width: '100%',
      padding: 5,
    },
    addItem: {
      position: 'relative',
      padding: '6px 10px',
      borderRadius: 20,
      marginBottom: 13,
      border: `1px solid #d2d2d2`,
      minWidth: 280,
      maxWidth: 'fit-content',
      font: theme.custom.font.paragraph,
      color: theme.custom.colors.placeholder,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      paddingRight: '30px'
    },
  };
});

export default useStyles;
